import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import { Dropdown } from 'antd';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { isChildNode } from 'utils/is-child-node';
import { EstimateField } from '../../fields';
import { DateFieldFilter } from '../../filters/date';
import { EstimateFieldFilter } from '../../filters/estimate';
import { Trigger } from './components';
import { format } from './format';
import { renderOverlay } from './overlay';

interface Props {
  filter: EstimateFieldFilter;
  onChange: (filter: EstimateFieldFilter) => void;
  getFilterOperationTypeOptions?: (field: EstimateField) => DateFieldFilter[];
}

export const EstimateCriteria: FC<Props> = ({ filter, onChange }) => {
  const [visible, setVisible] = useState(false);
  const isChild = isChildNode([
    'date-criteria',
    'ant-dropdown',
    'ant-picker-dropdown',
  ]);
  const close = useCallback(
    (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;

      if (target != null && !isChild(target)) {
        setVisible(false);
      }
    },
    [setVisible, isChild],
  );

  useEffect(() => {
    if (!visible) {
      return () => {};
    }
    document.addEventListener('click', close);

    return () => {
      document.removeEventListener('click', close);
    };
  }, [close, visible]);

  return (
    <Dropdown
      trigger={['click']}
      visible={visible}
      overlay={renderOverlay(filter, onChange)}
    >
      <Trigger className="date-criteria" onClick={() => setVisible(!visible)}>
        <span>{format(filter)}</span>
        <ChevronDown16 />
      </Trigger>
    </Dropdown>
  );
};
